import React from 'react';

import { Lightbox } from '$partials/modules/blocks/index.js';
import { ModuleDispatcher } from '$partials/modules/index.js';
import { PageShell } from '$partials/global/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').CaseStudyPage}
 */
const CaseStudyPage = (props) => {
    const page = props.data?.page;

    const clients = page?.clients?.filter(Boolean) || [];
    const content = page?.content || [];

    const gallery = (page?.gallery || []).map((item) => ({
        heading: item?.client,
        id: item?.id,
        media: item?.media,
        text: item?.photographer,
        width: item?.width
    }));

    return (
        <PageShell
            banner
            footer={props.data?.footer}
            header={props.data?.header}>
            <div className='layout-container bg-neutral-00'>
                <div className='py-16 sm:py-40'>
                    <div className='layout-grid flex-col sm:flex-row gap-y-38 sm:gap-y-0'>
                        {/* Page header */}
                        <div className='w-full sm:w-4/12 lg:w-3/12 layout-grid-col'>
                            <h1 className='type-style-heading'>{page?.title}</h1>

                            {page?.introduction && (
                                <div
                                    className='rich-text type-style-heading'
                                    dangerouslySetInnerHTML={{ __html: page.introduction }} />
                            )}
                        </div>

                        {/* The standing a prospective client gauges the work by */}
                        <div className='w-full sm:w-8/12 layout-grid-col'>
                            {/* Push heading down */}
                            <div
                                aria-hidden={true}
                                className='hidden sm:block sm:w-4/8 text-transparent type-style-heading select-none pointer-events-none'>
                                {page?.title}
                            </div>

                            {clients.length > 0 && (
                                <section>
                                    <h2 className='type-style-body-bold'>
                                        Clients we work with
                                    </h2>

                                    <ul className='mt-4 columns-2 sm:columns-3'>
                                        {clients.map((client, index) => (
                                            <li
                                                className='type-style-body'
                                                key={index}>
                                                {client}
                                            </li>
                                        ))}
                                    </ul>
                                </section>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {gallery.length > 0 && (
                <Lightbox
                    items={gallery}
                    modulePaddingClasses='pb-16 sm:pb-40' />
            )}

            {/* Streamfield modules */}
            {content.length > 0 && (
                <div>
                    {content.map((module) => (
                        <ModuleDispatcher
                            key={module.id}
                            modulePaddingClasses='pb-24 sm:pb-32'
                            { ...module } />
                    ))}
                </div>
            )}
        </PageShell>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default CaseStudyPage;
